import React, { useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import '../assets/css/EnquiryForm.css';
import { API_BASE_URL } from '../config';

const EnquiryForm = ({ isOpen, onClose, productName, productSku }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    product_name: productName,
    product_sku: productSku
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [connectionTested, setConnectionTested] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handlePhoneChange = (value) => {
    setFormData({
      ...formData,
      phone: value
    });
  };

  const testConnection = async () => {
    try {
      console.log('Testing API connection:', `${API_BASE_URL}test.php`);
      const response = await fetch(`${API_BASE_URL}test.php`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('API test response:', data);
      
      if (data.success) {
        setConnectionTested(true);
        return true;
      } else {
        throw new Error(data.message || 'API test failed');
      }
    } catch (err) {
      console.error('API connection test failed:', err);
      setError(`Connection test failed: ${err.message}. Please check if your local server is running and the API endpoint is accessible.`);
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    // Test connection first if not already tested
    if (!connectionTested) {
      const connectionSuccess = await testConnection();
      if (!connectionSuccess) {
        setLoading(false);
        return;
      }
    }

    try {
      console.log('Submitting enquiry with data:', formData);
      console.log('API URL:', `${API_BASE_URL}enquiries.php`);

      const response = await fetch(`${API_BASE_URL}enquiries.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      console.log('Response status:', response.status);
      console.log('Response ok:', response.ok);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('Response data:', data);

      if (data.success) {
        setSuccess('Thank you for your enquiry. We will contact you soon!');
        setFormData({
          name: '',
          email: '',
          phone: '',
          message: '',
          product_name: productName,
          product_sku: productSku
        });
        setTimeout(() => {
          onClose();
        }, 3000);
      } else {
        setError(data.message || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      console.error('Error submitting enquiry:', err);
      
      if (err.message.includes('Failed to fetch')) {
        setError('Network error. Please check your internet connection and try again.');
      } else if (err.message.includes('HTTP error')) {
        setError(`Server error (${err.message}). Please try again later.`);
      } else if (err.name === 'SyntaxError') {
        setError('Invalid response from server. Please try again.');
      } else {
        setError(`Failed to submit enquiry: ${err.message}. Please try again.`);
      }
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="enquiry-modal-overlay">
      <div className="enquiry-modal">
        <button className="close-button" onClick={onClose}>&times;</button>
        <h2>Product Enquiry</h2>
        
        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}
        
        {/* {!connectionTested && (
          <div className="connection-status">
            <p style={{color: '#666', fontSize: '14px', marginBottom: '10px'}}>
              📡 Testing connection to server...
            </p>
            <button 
              type="button" 
              onClick={testConnection}
              style={{
                background: '#007bff',
                color: 'white',
                border: 'none',
                padding: '5px 10px',
                borderRadius: '4px',
                fontSize: '12px',
                cursor: 'pointer',
                marginBottom: '15px'
              }}
            >
              Test API Connection
            </button>
          </div>
        )} */}
        
        {connectionTested && (
          <div style={{color: '#28a745', fontSize: '14px', marginBottom: '15px'}}>
            ✅ Connected to server successfully
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter your name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Enter your email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone Number *</label>
            <PhoneInput
              country={'ae'}
              value={formData.phone}
              onChange={handlePhoneChange}
              inputProps={{
                required: true,
                name: 'phone'
              }}
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Message *</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              placeholder="Enter your message"
              rows="4"
            />
          </div>

          <div className="product-info">
            <p><strong>Product:</strong> {productName}</p>
            <p><strong>SKU:</strong> {productSku}</p>
          </div>

          <button 
            type="submit" 
            className="enquiry-button"
            disabled={loading}
          >
            {loading ? 'Loading.....' : 'Send Enquiry'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EnquiryForm; 